import Form from "../Form/Form";
import css from "./AddEquipment.module.css";
import AddEquipmentOptions from "./AddEquipmentOptions";
import { useState, useEffect } from "react";
import Utils from "../../Services/Utills";
import { Get } from "../../Services/Server";
import Url from "../../Services/Url";
import User from "../../Services/User";
import { toast } from "react-toastify";

const AddEquipment = ({ onSubmit, task, companyId }) => {
	const [options, setOptions] = useState(AddEquipmentOptions);

	useEffect(() => {
		if (task) {
			const op = { ...options };
			op.Fields[0].value = task.taskEquipmentList?.[0]?.name || "";
			op.Fields[1][0].value = task.taskEquipmentList?.[0]?.type || "";
			op.Fields[1][1].value = task.taskEquipmentList?.[0]?.template || null;
			setOptions(op);
		}
	}, [task]);

	const init = () => {
		const op = { ...options };
		op.Fields[0].value = "";
		op.Fields[1][0].value = "";
		op.Fields[1][1].value = "";
		setOptions(op);
	};

	const taskChange = (e) => {
		if (e && typeof e === "object") {
			Get(Url.taskTemplates(`MRT${companyId}`, e.id))
				.then((resp) => {
					const op = { ...options };
					op.Fields[1][1].options = resp;
					setOptions(op);
				})
				.catch((err) => {
					toast(err);
				});
		}
	};

	const handleSubmit = () => {
		if (task) {
			options.index = task.index;
		}
		onSubmit && onSubmit(options);
		init();
	};

	options.Fields[1][0].onSelected = taskChange;

	return (
		<div className={css.AddEquipment}>
			{options && <Form onSubmit={handleSubmit}>{options}</Form>}
		</div>
	);
};

export default AddEquipment;
